// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
    margin: 0;
    padding: 0;
}

:root {

    --primary-100: #e95a13;
    --primary-200: #4e7799;
    --primary-300: #FFFFFF;
    --accent-100: #94a9ba;
    --accent-200: #e0946e;
    --text-100: #4A4A4A;
    --text-200: #878787;
    --bg-100: #F5F3F7;
    --bg-200: #aebcc7;
    --bg-300: #f3cab6;
    color: var(--text-100);
    transition: 300ms color ease-in-out;

}




.notfound-container {
    text-align: center;
    margin-top: 10%;
}

.notfound-container p {
    font-size: 30px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;IACI,SAAS;IACT,UAAU;AACd;;AAEA;;IAEI,sBAAsB;IACtB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB;IACjB,iBAAiB;IACjB,iBAAiB;IACjB,sBAAsB;IACtB,mCAAmC;;AAEvC;;;;;AAKA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB","sourcesContent":["* {\n    margin: 0;\n    padding: 0;\n}\n\n:root {\n\n    --primary-100: #e95a13;\n    --primary-200: #4e7799;\n    --primary-300: #FFFFFF;\n    --accent-100: #94a9ba;\n    --accent-200: #e0946e;\n    --text-100: #4A4A4A;\n    --text-200: #878787;\n    --bg-100: #F5F3F7;\n    --bg-200: #aebcc7;\n    --bg-300: #f3cab6;\n    color: var(--text-100);\n    transition: 300ms color ease-in-out;\n\n}\n\n\n\n\n.notfound-container {\n    text-align: center;\n    margin-top: 10%;\n}\n\n.notfound-container p {\n    font-size: 30px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
